<template lang="pug">
  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
    thead.thead-light
      tr
        th.text-center(width="8%")
          span #
        th(width="18%" @click="sortOrder('transfer_date', 'report')")
          span(:title="$t('ui.transfer_date')") {{ $t('ui.transfer_date') }}
        th(width="10%")
          span(:title="$t('ui.transfer_type')") {{ $t('ui.transfer_type') }}
        th(width="10%")
          span(:title="$t('ui.method')") {{ $t('ui.method') }}
        th(width="10%")
          span(:title="$t('ui.bank_id')") {{ $t('ui.bank_id') }}
        th(width="10%")
          span(:title="$t('ui.bank_acc_no')") {{ $t('ui.bank_acc_no') }}
        th(width="10%")
          span(:title="$t('ui.bank_acc_holder')") {{ $t('ui.bank_acc_holder') }}
        th(width="10%")
          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
        th(width="10%")
          span(:title="$t('ui.ref_no')") {{ $t('ui.ref_no') }}
        th(width="10%")
          span(:title="$t('ui.remark')") {{ $t('ui.remark') }}
        th.text-right(width="18%")
          span(:title="$t('ui.credit')") {{ $t('ui.credit') }}
        th.text-right(width="18%")
          span(:title="$t('ui.debit')") {{ $t('ui.debit') }}
    tbody.clusterize-content
      tr(v-if="tbl.length == 0")
        td(:colspan="12").text-center
          span {{ $t('message.no_data_available') }}
      tr(v-for="(item, index) in tbl")
        td.text-center
          span(:title="index + 1") {{ index + 1 }}
        td
          span(:title="$moment(item.transfer_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.transfer_date).format('YYYY-MM-DD, HH:mm:ss') }}
        td
          span.font-weight-bold {{ item.transfer_type }}
        td
          span.d-block {{ item.transfer_method }}
        td
          span.d-block {{ item.bank_id }}
        td
          span.d-block {{ item.bank_acc_no }}
        td
          span.d-block {{ item.bank_acc_holder }}
        td
          span.d-block {{ item.account_id }}
        td
          span.d-block {{ item.ref_no }}
        td
          span.d-block {{ item.remark }}
        td.text-right
          span.font-weight-bold(:title="$n(item.credit_amount, 'currency')") {{ $n(item.credit_amount, 'currency') }}
        td.text-right
          span.font-weight-bold.text-danger(:title="$n(item.debit_amount, 'currency')") {{ $n(item.debit_amount, 'currency') }}
      tr.footer
        td.text-right(colspan="10")
          span {{ $t("ui.sub_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalCreditAmount)" :title="$n(subTotalCreditAmount, 'currency')") {{ $n(subTotalCreditAmount, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalDebitAmount)" :title="$n(subTotalDebitAmount, 'currency')") {{ $n(subTotalDebitAmount, 'currency') }}
      tr.footer
        td.text-right(colspan="10")
          span {{ $t("ui.grand_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalCreditAmount)" :title="$n(grandTotalCreditAmount, 'currency')") {{ $n(grandTotalCreditAmount, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDebitAmount)" :title="$n(grandTotalDebitAmount, 'currency')") {{ $n(grandTotalDebitAmount, 'currency') }}
</template>
<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    totalTbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    loading: false,
    subTotalCreditAmount: 0,
    grandTotalCreditAmount: 0,
    subTotalDebitAmount: 0,
    grandTotalDebitAmount: 0
  }),
  watch: {
    tbl(newValue, oldValue) {
      this.getTotal();
    },
  },
  mounted() {
    this.getTotal();
  },
  methods: {
    clearTotal() {
      this.subTotalCreditAmount = 0
      this.grandTotalCreditAmount = 0
      this.subTotalDebitAmount = 0
      this.grandTotalDebitAmount = 0
    },
    getTotal: function() {
      this.clearTotal();
      var tbl = this.tbl;
      if(tbl.length > 0) {
        tbl.forEach(value => {
          this.subTotalCreditAmount = parseFloat(this.subTotalCreditAmount) + parseFloat(value["credit_amount"]);
          this.subTotalDebitAmount = parseFloat(this.subTotalDebitAmount) + parseFloat(value["debit_amount"]);
        });

        var totalTbl = this.totalTbl;
        if(totalTbl.length > 0) {
          this.grandTotalCreditAmount = totalTbl[0]["credit_amount"];
          this.grandTotalDebitAmount = totalTbl[0]["debit_amount"];
        }
      }
    }
  }
};
</script>
